// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as InputField$OrcaPaymentPage from "./Components/InputField.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as WalletShimmer$OrcaPaymentPage from "./Components/WalletShimmer.bs.js";
import * as CardCVCElement$OrcaPaymentPage from "./CardCVCElement.bs.js";
import * as CardElementShimmer$OrcaPaymentPage from "./Components/CardElementShimmer.bs.js";
import * as PaymentElementShimmer$OrcaPaymentPage from "./Components/PaymentElementShimmer.bs.js";
import * as PaymentManagementLazy$OrcaPaymentPage from "./PaymentManagementLazy.bs.js";
import * as ReusableReactSuspense$OrcaPaymentPage from "./hyper-log-catcher/ReusableReactSuspense.bs.js";
import * as SingleLineCardPaymentLazy$OrcaPaymentPage from "./SingleLineCardPaymentLazy.bs.js";
import * as PaymentElementRendererLazy$OrcaPaymentPage from "./PaymentElementRendererLazy.bs.js";

function RenderPaymentMethods(props) {
  var isFocus = props.isFocus;
  var handleElementFocus = props.handleElementFocus;
  var cvcProps = props.cvcProps;
  var expiryProps = props.expiryProps;
  var cardProps = props.cardProps;
  var paymentType = props.paymentType;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var showLoader = match.showLoader;
  var match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match$1.localeString;
  var themeObj = match$1.themeObj;
  var blur = props.blurState ? "blur(2px)" : "";
  var frameRef = React.useRef(null);
  var tmp;
  switch (paymentType) {
    case "Card" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(SingleLineCardPaymentLazy$OrcaPaymentPage.make, {
                    paymentType: paymentType,
                    cardProps: cardProps,
                    expiryProps: expiryProps,
                    cvcProps: cvcProps,
                    zipProps: props.zipProps,
                    handleElementFocus: handleElementFocus,
                    isFocus: isFocus
                  }),
              loaderComponent: React.createElement(RenderIf$OrcaPaymentPage.make, {
                    condition: showLoader,
                    children: React.createElement(CardElementShimmer$OrcaPaymentPage.make, {})
                  }),
              componentName: "SingleLineCardPaymentLazy"
            });
        break;
    case "CardNumberElement" :
        tmp = React.createElement(InputField$OrcaPaymentPage.make, {
              isValid: cardProps.isCardValid,
              id: "card-number",
              setIsValid: cardProps.setIsCardValid,
              value: cardProps.cardNumber,
              onChange: cardProps.changeCardNumber,
              onBlur: cardProps.handleCardBlur,
              onFocus: handleElementFocus,
              type_: "tel",
              maxLength: cardProps.maxCardLength,
              placeholder: "1234 1234 1234 1234",
              inputRef: cardProps.cardRef,
              isFocus: isFocus,
              autocomplete: "cc-number"
            });
        break;
    case "CardExpiryElement" :
        tmp = React.createElement(InputField$OrcaPaymentPage.make, {
              isValid: expiryProps.isExpiryValid,
              id: "card-expiry",
              setIsValid: expiryProps.setIsExpiryValid,
              value: expiryProps.cardExpiry,
              onChange: expiryProps.changeCardExpiry,
              onBlur: expiryProps.handleExpiryBlur,
              onFocus: handleElementFocus,
              type_: "tel",
              maxLength: 7,
              placeholder: localeString.expiryPlaceholder,
              inputRef: expiryProps.expiryRef,
              isFocus: isFocus,
              autocomplete: "cc-exp"
            });
        break;
    case "CardCVCElement" :
        tmp = React.createElement(CardCVCElement$OrcaPaymentPage.make, {
              cvcProps: cvcProps,
              paymentType: paymentType
            });
        break;
    case "PaymentMethodsManagement" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(PaymentManagementLazy$OrcaPaymentPage.make, {
                    paymentType: paymentType,
                    cardProps: cardProps,
                    expiryProps: expiryProps,
                    cvcProps: cvcProps
                  }),
              loaderComponent: React.createElement(RenderIf$OrcaPaymentPage.make, {
                    condition: showLoader,
                    children: React.createElement(PaymentElementShimmer$OrcaPaymentPage.make, {})
                  }),
              componentName: "PaymentManagementLazy"
            });
        break;
    case "PaymentMethodCollectElement" :
    case "NONE" :
        tmp = null;
        break;
    default:
      tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
            children: React.createElement(PaymentElementRendererLazy$OrcaPaymentPage.make, {
                  paymentType: paymentType,
                  cardProps: cardProps,
                  expiryProps: expiryProps,
                  cvcProps: cvcProps
                }),
            loaderComponent: React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: showLoader,
                  children: Utils$OrcaPaymentPage.checkIsWalletElement(paymentType) ? React.createElement(WalletShimmer$OrcaPaymentPage.make, {}) : React.createElement(PaymentElementShimmer$OrcaPaymentPage.make, {})
                }),
            componentName: "PaymentElementRendererLazy"
          });
  }
  return React.createElement("div", {
              className: "flex flex-col justify-between PaymentMethodContainer",
              dir: localeString.localeDirection,
              style: {
                background: "transparent",
                color: themeObj.colorText,
                fontFamily: themeObj.fontFamily,
                fontSize: themeObj.fontSizeBase,
                marginTop: "4px",
                marginRight: "4px",
                marginBottom: "4px",
                marginLeft: "4px",
                filter: blur
              }
            }, React.createElement("div", {
                  ref: Caml_option.some(frameRef),
                  className: "m-auto flex justify-center md:h-auto  w-full h-auto "
                }, React.createElement("div", {
                      className: "w-full font-medium"
                    }, tmp)));
}

var make = RenderPaymentMethods;

export {
  make ,
}
/* jotai Not a pure module */
